// Utils
import { detectChanges } from '../detectChanges';
import { commitGivenValues } from './commitGivenValues';
/**
 * This builds a list of changes between that describe the differences between `previousValues`
 * and `values`. These are derived changes that represent the difference.
 *
 * There is no guarantee as optimality of those changes being applied, and they may differ from the
 * actual changes that were applied i.e. it don't know how new values got to where they are.
 * However applying these changes to `previousValues` will result in `values`.
 *
 * @template {T}
 * @param {T} previousValues
 * @param {T} values
 *
 * @return {ChangeList}
 */
export function detectChangesBetweenValues(previousValues, values) {
    var valuesWithCommittedPreviousValues = commitGivenValues(values, previousValues);
    return detectChanges(valuesWithCommittedPreviousValues);
}
//# sourceMappingURL=detectChangesBetweenValues.js.map